module.exports = __webpack_public_path__ + "img/room_service.ef31df00.svg";